/**
 * 会話履歴が0件のとき（初回表示・会話リセット直後）に
 * チャットメッセージ欄の代わりに表示する案内コンポーネント。
 */
const ChatEmptyState = () => (
  <div className="chat-empty-state">
    <div className="chat-empty-icon">💬</div>
    <p className="chat-empty-title">AIに質問する</p>
    <p className="chat-empty-desc">
      表示中のPDF書類の内容についてAIに質問できます。
      <br />
      特定ページについて聞く場合は、質問文にページ番号をご記載ください。
    </p>
  </div>
);

export default ChatEmptyState;
